export enum MenuCode {
    SocialNetworks, PublicFooter, PublicMenu
}